export const environment = {
  clientId: 'community-spa'
};
